import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import { getDecoratedTask } from './get-decorated-task';
import type { TaskRowContext } from './get-task-row';
import { getTaskRow } from './get-task-row';
import { getTasksWithNicknames } from './get-tasks-with-nicknames';

export interface TaskRowsContext extends TaskRowContext {
  dispensaries: { id: string; name: string }[];
}

/** Turns a bank tasks response into the rows both task tables render. */
export const getTaskRows = (tasks: (MinifiedTask | GroupedTask)[], context: TaskRowsContext) =>
  getTasksWithNicknames(tasks, context.dispensaries).map((task) =>
    getTaskRow(getDecoratedTask(task), context)
  );
